export enum IbanStatus {
  NEW = 'NEW',
  SELECTED = 'SELECTED'
}

const IBAN_STATUS_SELECTED_BACKGROUND = 'rgba(86,240,0,0.2)';
const IBAN_STATUS_NEW_BACKGROUND = 'rgba(45,204,255,0.2)';

export const createIbanStatusStyle = (
  backgroundColor: string
): { color: string; backgroundColor: string } => ({
  color: 'rgba(0, 0, 0, 0.80)',
  backgroundColor
});

export const IBAN_STATUS_COLORS = {
  [IbanStatus.SELECTED]: createIbanStatusStyle(IBAN_STATUS_SELECTED_BACKGROUND),
  [IbanStatus.NEW]: createIbanStatusStyle(IBAN_STATUS_NEW_BACKGROUND)
};
